import * as React from 'react'

interface Props {
    path?: string
    name: string
    handler: (e: React.FormEvent<HTMLInputElement> | React.MouseEvent<HTMLImageElement>) => void
    accepts?: string
    title: string
}

export const NewMmoButton: React.FC<Props> = ({ path, name, handler, accepts, title, children }) => {
    const addHover = (path: string) => {
        let str = path.substring(0, path.length - 4);
        str += "-hover.png";
        return str;
    };

    return (
        <div className="div_styles add_buttons" title={title}>
            <label>
                {children}
                {accepts && <input
                    //@ts-ignore
                    hidden="hidden"
                    type="file"
                    accept={accepts}
                    onInput={(e) => {
                        handler!(e)
                        // Copied from https://stackoverflow.com/a/39485234
                        //@ts-ignore need this error for proper handling in chrome/safari
                        e.currentTarget.value = null;
                    }}

                />}
                <span>{name}</span>
            </label>
        </div>
    )
}
